<template>
  <div class="view">
    <div class="title">
      <i class="goback el-icon-arrow-left" @click="goback"></i>
      {{titleinfo}}
    </div>
    <div class="content">
      <div class="set_flexwrap">
        <div class="flex_wrap">
          <el-form ref="form" :rules="editFormRules" :model="editForm" label-width="210px">
            <el-row>
              <el-col :span="16">
                <el-form-item label="获取方式:" prop="get_type">
                  <el-radio-group v-model="editForm.get_type">
                    <el-radio :label="0">小程序展示</el-radio>
                    <el-radio :label="1">仅内部获取</el-radio>
                    <el-radio :label="2">营销活动券</el-radio>
                  </el-radio-group>
                  <div class="whd-gray999" style="line-height: 24px">
                    1.若选择小程序展示，用户可直接前往小程序商城页面直接领取 <br/>
                    2.若选择内部获取，需要在企业后台将该卡券分发给其他员工，员工可在APP中进行分享<br/>
                    3.营销活动券，用户购买/参与指定活动，会获取对应数量的优惠券
                  </div>
                </el-form-item>
              </el-col>
            </el-row>            
            <el-row>
              <el-col :span="11">
                <el-form-item label="名称:" prop="name">
                  <el-input v-model="editForm.name" auto-complete="off" placeholder="填写名称" ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="劵类型:" prop="coupon_type">
                  <el-select class="whd-select" clearable v-model="editForm.coupon_type" placeholder="请选择劵类型" size="small"
                             @change="changeCouponType">
                    <el-option
                            v-for="(item,index) in goodstype"
                            :value="item.value"
                            :label="item.label"
                            :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              
            </el-row>
            <el-row>
              <el-col :span="16">
                <el-form-item label="折扣:" prop="discount" v-if="editForm.coupon_type==2">
                  <el-input v-model="editForm.discount" auto-complete="off" placeholder="请输入折扣" class="w105 mr10"></el-input><span class="whd-gray999 ml10">折扣（范围0.1-9.9）</span> 
                </el-form-item>
                <el-form-item label="面额:" prop="cash" v-if="editForm.coupon_type==3||editForm.coupon_type==4">
                  <el-input v-model="editForm.cash" auto-complete="off" placeholder="请输入面额" class="w105 mr10"></el-input><span class="whd-gray999">{{editForm.coupon_type==3?'线上领取线上无门槛使用':'线上领取到店抵现金使用，需线上核销'}}</span> 
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="editForm.coupon_type==1">
              <el-col :span="8">
                <el-form-item label="多少满减:" prop="full">
                  <el-input v-model="editForm.full" auto-complete="off" placeholder="多少满减"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="减多少:" prop="reduction">
                  <el-input v-model="editForm.reduction" auto-complete="off" placeholder="减多少"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8"></el-col>
            </el-row>
            <el-row v-if="editForm.get_type == 1">
              <el-col :span="11">
                <!-- <el-form-item label="员工分发张数:" prop="limit"> -->
                <el-form-item label="员工单次分享数量:" prop="limit">
                  <el-input v-model="editForm.limit" auto-complete="off" placeholder="0代表无限，但受总数限制"></el-input>
                </el-form-item>
              </el-col>
             
              <el-col :span="8"></el-col>
            </el-row>
            <el-row v-if="editForm.get_type != 2">
               <el-col :span="11">
                <el-form-item label="派发总数:" prop="count">
                  <el-input v-model="editForm.count" auto-complete="off" placeholder="派发数量必须大于0"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="editForm.get_type==1">
              <el-col :span="20">
                <el-form-item label="分发方式:" prop="send_type">
                  <el-radio-group v-model="editForm.send_type">
                    <el-radio :label="0">平均分发</el-radio>
                    <el-radio :label="1">自定义分发</el-radio>
                  </el-radio-group>
                  <div class="whd-gray999" style="line-height: 24px">
                    1.平均分发：发放张数/选择员工数量，若卡券有剩余可自行进行自定义分配（例：发放张数10张，我平均分发给3名员工，那么剩余一张可自定义进行指派给任意员工） <br/>
                    2.自定义分发：可自行选择员工数量以及每名员工领取的卡券张数
                  </div>
                </el-form-item>
              </el-col>
            </el-row> 
            <el-row v-if="editForm.get_type==1">
              <el-col :span="20">
                <el-form-item label="选择员工:" prop="yg_num">
                  <el-button size="small" @click="onSelectEmployee">选择员工</el-button>
                  <div style="margin-left: 80px">
                    <el-tag type="info" v-for="item in yg_num" :key="item.eid">{{item.name}}({{item.num}})</el-tag>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>   
            <!-- <el-row v-if="editForm.get_type != 2">
              <el-col :span="16">
                <el-form-item label="短信召回客户:" prop="is_sms_recall">
                  <el-radio-group v-model="editForm.is_sms_recall">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>   
                  <span class="ml-10 whd-gray999">该卡券快到期后的前15/7/3天，会给已领取卡券的客户下发一条短信提醒客户（该短信会有一条直达小程序的链接）</span>
                </el-form-item>             
              </el-col>
            </el-row>   -->
            <el-row v-if="editForm.get_type != 2">
              <el-col :span="24" v-if="editForm.get_type==0">
                <el-form-item label="商城首页展示:" prop="is_index">
                  <el-radio-group v-model="editForm.is_index">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                  <span class="ml-10 whd-gray999">若选择是之后该优惠券会在小程序首页展示</span>
                </el-form-item>
              </el-col>            
              <el-col :span="24">
                <el-form-item label="通知提醒客户:" prop="is_notice">
                  <!--0 否 1是-->
                  <div style="display: flex;align-items: center;">
                    <el-radio-group v-model="editForm.is_notice">
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                    <div class="ml-10  whd-gray999" >到期前2天通过服务通知提醒客户</div>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="editForm.get_type==0">
                <el-form-item label="开屏弹窗:" prop="is_popup">
                  <el-radio-group v-model="editForm.is_popup">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                  <span class="whd-gray999" style="padding-left: 20px">若选择是的话，客户首次进入小程序后将自动弹出该优惠券</span>
                </el-form-item>
              </el-col>  
            </el-row>
            <el-row v-if="editForm.get_type==2">
              <el-col :span="24">
                <el-form-item label="选择活动:" prop="activity">
                  <el-button size="medium" @click="dialogActivity = true">选择活动</el-button>
                  <div>
                    <el-tag type="info" v-for="item in activity_list" :key="item.activity_id">{{item.title}}</el-tag>
                  </div> 
                </el-form-item>
              </el-col> 
            </el-row>   
            <el-row  v-if="editForm.get_type==2">
              <el-col :span="24">
                <p style="margin-bottom: 15px; padding-left: 40px; font-size: 14px; color: #606266">
                  用户购买活动后，会获得
                  <el-input type="number" v-model="editForm.activity_num" auto-complete="off" placeholder="填写张数" class="w100 mr10 ml10"></el-input>
                  张优惠券
                </p>
              </el-col>
            </el-row>    
            <el-row>
              <el-col :span="24">
                <el-form-item label="有效期:">
                  <el-radio-group v-model="editForm.date_type" @change="changeDateType">
                    <el-radio :label="item.value" v-for="(item,index) in datatypeline" :key="index">{{item.label}}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="">
                  <el-date-picker
                          v-model="dataTime"
                          type="daterange"
                          range-separator="-"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          size="small"
                          :picker-options="pickerOptions1"
                          v-if="editForm.date_type==2"
                  ></el-date-picker>
                  <div style="display: flex;" v-else>
                    领后
                    <el-input v-model="editForm.date_type_1" auto-complete="off" placeholder="填写天数"
                              class="w100 mr10 ml10"></el-input>
                    天内有效
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
              </el-col>
              <el-col :span="8"></el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="限定商品:">
                  <el-radio-group v-model="editForm.type" @change="couponType">
                    <el-radio :label="item.value" v-for="(item,index) in specialGoods" :key="index">{{item.label}}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <el-form-item label="">
                  <div v-if="editForm.type==2">
                    指定商品分类：
                    <template v-if="cateList.length>0">
                      <div class="goodsType"><span v-for="(item,index) in cateList" :key="index">{{item.name}}</span></div>
                    </template>
                    <template v-else>
                      <div class="goodsType"><span v-for="(item,index) in defaultCate" :key="index">{{item}}</span></div>
                    </template>
                    <el-button size="small" @click="gettypeFn(1)">选择分类</el-button>
                  </div>
                  <div v-if="editForm.type==3">
                    指定商品：
                    <div class="goodsType">
                      <template v-if="goodsList.length>0">
                        <span v-for="(item,index) in goodsList" :key="index">
                          {{item.goods_name}}
                        </span>                        
                      </template>  
                      <template v-else>
                        <span v-for="(item,index) in defaultGoods" :key="index">
                          {{item}}
                        </span>                       
                      </template>
                    </div>
                    <el-button size="small" @click="gettypeFn(2)">选择商品</el-button>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="11">
                <el-form-item label="使用说明:" prop="instructions">
                  <el-input v-model="editForm.instructions" auto-complete="off" placeholder="填写使用说明"
                            type="textarea"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16">
                <el-form-item class="is-required whd-form-item" label="微信分享图片" prop="share_img">
          <div class="addicon">
            <div class="el-upload el-upload--text" @click="corppervisible2 = true">
              <ul v-if="editForm.share_img" class="perview_img">
                <li><img :src="editForm.share_img" /></li>
              </ul>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </div>
            <div class="el-upload__tip">可选填，图片建议尺寸500*400，支付JPG、PNG格式</div>
          </div> 
        </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16">
                <el-form-item label="">
                  <el-button type="primary" size="small" @click="savegood('form')">保存</el-button>
                  <el-button size="small" @click="goback">取消</el-button>
                </el-form-item>
              </el-col>
              <el-col :span="8">
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
    <couponDialog
            :visible.sync="addcheckemployeedialog"
            v-if="addcheckemployeedialog"
            :type="editForm.type"
            @getInfoFn="getInfoFn"
    ></couponDialog>
    <selectEmployeeDialog 
            v-if="selectemployeedialog" 
            :visible.sync="selectemployeedialog"
            :totalNumber="editForm.count"
            :send_type="editForm.send_type"
            @selectDataBack="selectDataBack"
    ></selectEmployeeDialog> 
    <corpper2 :visible.sync="corppervisible2"
             v-if="corppervisible2" @imgAddBack2="imgAddBack2" :imgSize="16"></corpper2>
    <merchantDialog :visible.sync="dialogActivity" :type="1" @updatePageInfo="updatePageInfo"></merchantDialog>
  </div>
</template>
<script>
  import api from "@/api.js";
  import {yeartime, yeartime_} from '@/assets/js/common'
  import {coupontype, datetype, specialGoodsType} from "@/util/util.js";
  import couponDialog from "@/components/dialog/couponDialog.vue";
  import selectEmployeeDialog from "@/components/dialog/selectEmployeeDialog.vue";
  import merchantDialog from '@/components/tkdialog/merchantDialog';
  import corpper2 from "@/components/dialog/corpper2.vue";

  export default {
    name: "addOrEditGoods",
    components: {
      couponDialog,
      selectEmployeeDialog,
      corpper2,
      merchantDialog
    },
    data() {
      return {
        titleinfo: "",
        selectemployeedialog: false,
        addcheckemployeedialog: false,
        dialogActivity: false,
        corppervisible2: false,
        goodstype: coupontype,
        datatypeline: datetype,
        specialGoods: specialGoodsType,
        dataTime: [],
        pickerOptions1: {
          disabledDate(time) {
            return time.getTime() < Date.now(); //  - 8.64e7 减去就是不包含今天的
          },
        },
        editForm: {
          name: '',               // 优惠券名称
          coupon_type: 1,         // 优惠券类型：1--满减券，2--折扣券，3--代金券线，4--代金券线下
          discount: '',           // 折扣（coupon_type=2），eg:97=>97折
          full: '',               // 多少满减
          reduction: '',          // 减多少
          cash: '',               // 代金面额
          instructions: '',       // 说明
          count: '',              // 优惠券张数
          limit: '',              // 单用户限制张数，0不限制，>0限制的张数
          type: 1,                // 适用范围，1--全场通用，2--指定商品分类，3--指定商品
          type_2: '',             // 指定商品分类，eg:1,2,3
          type_3: '',             // 指定商品id，eg:1,2,3
          date_type: 1,           // 有效期，1--指定有效天数，2--指定有效日期
          date_type_1: '',        // 指定有效天数
          date_type_2_start: '',  // 指定有效日期，开始日期，eg：2019-11-12
          date_type_2_end: '',    // 指定有效日期，结束日期，eg：2019-12-12
          is_notice: 0,           // 是否到期前2天通过服务通知提醒客户
          is_index: 0,            // 是否到期前2天通过服务通知提醒客户
          is_popup: 0,            // 是否开屏弹窗
          get_type: '',           // 获取方式，0-小程序，1-仅内部员工
          send_type: '',          // 分发方式，0-平均，1-自定义
          is_sms_recall: '',      // 是否短信召回，0-否，1-是
          yg_num: [],
          aids: '',               // 指定活动id
          activity_num: '',        // 用户购买活动后，会获得几张优惠券
          share_img:'',
        },
        yg_num: [],
        editFormRules: {
          name: [
            {required: true, message: '请填写优惠券名称', trigger: 'blur'}
          ],
          full: [
            {required: true, message: '请填写多少满减', trigger: 'blur'}
          ],
          reduction: [
            {required: true, message: '请填写减多少', trigger: 'blur'}
          ],
          cash: [
            {required: true, message: '请填写面额', trigger: 'blur'}
          ],
          discount: [
            {required: true, message: '请填写折扣', trigger: 'blur'}
          ],
          limit: [
            {required: true, message: '请填写员工分发张数', trigger: 'blur'}
          ],
          count: [
            {required: true, message: '请填写发放张数', trigger: 'blur'}
          ],
          get_type: [
            {required: true, message: '请选择获取方式', trigger: 'change'}
          ],
          send_type: [
            {required: true, message: '请选择分发方式', trigger: 'change'}
          ],
          is_sms_recall: [
            {required: true, message: '请选择是否短信召回', trigger: 'change'}
          ],
          yg_num: [
            {required: true, message: '请选择员工以及领取卡券数量', trigger: 'change'}
          ]
        }, // 表单验证不能为空规则
        cateList: [],
        goodsList: [],
        detailId: this.$route.query,
        defaultGoods: [],
        defaultCate: [],
        activity_list: [],
        aids: ''
      };
    },
    created() {
      let titleinfo = "添加优惠券"
      if (this.detailId.id) {
        titleinfo = "编辑优惠券"
        this.detailFn()
      }
      this.titleinfo = titleinfo
    },
    methods: {
      detailFn() {
        let option = {
          cb_id: this.detailId.id,
          cate: 0
        }
        this.axios
            .post(api.discount_coupon_couponBag, option)
            .then(response => {
              if (response.data.code == 0) {
                for (let i in this.editForm) {
                  this.editForm[i] = response.data.data[i]
                }
                this.defaultCate = response.data.data.type_2_cate_name;
                this.defaultGoods = response.data.data.type_3_goods_name;
                if (response.data.data.date_type == 2) {
                  this.dataTime[0] = response.data.data.date_type_2_start;
                  this.dataTime[1] = response.data.data.date_type_2_end;
                }
                this.activity_list = response.data.data.activity_list;
                this.yg_num = response.data.data.yg_num;
              } 
            })
            .catch(response => {
            });
      },
      goback() {
        this.$router.go(-1);
      },
      changeDateType() {
        // dataTime: [], editForm.date_type_1
        if (this.editForm.date_type === 1) {
          this.dataTime = []
        } else {
          this.editForm.date_type_1 = ''
        }
      },
      gettypeFn() {
        this.addcheckemployeedialog = !this.addcheckemployeedialog
      },
      couponType() {
        this.defaultGoods = []
        this.goodsList = []
        this.editForm.type_2 = ""
        this.defaultCate = []
        this.cateList = []
        this.editForm.type_3 = ""
      },
      getInfoFn(option) {
        if (this.editForm.type === 2) {
          this.cateList = option
        }
        if (this.editForm.type === 3) {
          this.goodsList = option
        }
        
      },
      imgAddBack2(option) {
      this.editForm.share_img = option;
    },
      savegood(formName) {
        this.$refs[formName].validate(async valid => {
          if (valid) {
            // date_type: 1,// 有效期，1--指定有效天数，2--指定有效日期
            if (this.editForm.date_type === 1 && !this.editForm.date_type_1) {
              this.$message({
                message: "请填写有效天数",
                type: "warning"
              });
              return
            }

            if (this.editForm.date_type === 2 && this.dataTime.length < 1) {
              this.$message({
                message: "请选择有效日期",
                type: "warning"
              });
              return
            }
            if (this.editForm.date_type === 2) {
              this.editForm.date_type_2_start = this.dataTime[0] //指定有效日期，开始日期，eg：2019-11-12
              this.editForm.date_type_2_end = this.dataTime[1] // 指定有效日期，结束日期，eg：2019-12-12
            }
            // type: 1, // 适用范围，1--全场通用，2--指定商品分类，3--指定商品
            if (this.editForm.type === 2) {
              if (!this.editForm.type_2 && this.cateList.length < 1) {
                this.$message({
                  message: "请选择指定商品分类",
                  type: "warning"
                });
                return
              }

              if (this.cateList.length > 0) {
                let cateId = [];
                for (let i in this.cateList) {
                  cateId.push(this.cateList[i].id)
                }
                this.editForm.type_2 = cateId.join(',')
              }
            }
  
            if (this.editForm.type === 3) {
              if (!this.editForm.type_3 && this.goodsList.length < 1) {
                this.$message({
                  message: "请选择指定商品",
                  type: "warning"
                });
                return
              }

              if (this.goodsList.length > 0) {
                let goodsId = [];
                for (let i in this.goodsList) {
                  goodsId.push(this.goodsList[i].id)
                }
                this.editForm.type_3 = goodsId.join(',')   
              }           
            }
 
            this.submitsave();
            // this.$message({
            //   message: "请选择商品类目项",
            //   type: "warning"
            // });
            // this.$message({
            //   type: "error",
            //   message: "线上支付商品需先配置微信支付"
            // });
          } else {
            return false;
          }
        });
      },
      submitsave(params) {
        // cate 	整型 	非必填 	- 	- 	0--查，1--改，2--增，3--删
        if (this.detailId.id) {
          this.editForm.cate = 1
          this.editForm.cb_id = this.detailId.id
        } else {
          this.editForm.cate = 2
        }
        this.axios
            .post(api.discount_coupon_couponBag, this.editForm)
            .then(response => {
              this.lock = true;
              if (response.data.code == 0) {
                this.defaultGoods = [];
                this.defaultCate = [];
                this.goodsList = [];
                this.cateList = [];
                this.dataTime = [];
                this.$refs['form'].resetFields();
                this.yg_num = [];
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
              } 
            })
            .catch(response => {
              this.lock = true;
            });
      },
      changeCouponType() {
        if (this.editForm.coupon_type !== 2) {
          this.editForm.discount = ''
        }
        if (this.editForm.coupon_type !== 1) {
          this.editForm.full = ''
          this.editForm.reduction = ''
        }
      },
      onSelectEmployee() {
        if (!this.editForm.count) {
          this.$message.warning('请先填写发放张数');
          return
        } 
        if (this.editForm.count <= 0) {
          this.$message.warning('发放数量必须大于0');
          return
        } 
        if (this.editForm.send_type === 0 || this.editForm.send_type === 1) {

        } else {
          this.$message.warning('请先选择分发方式');
          return
        }
        this.selectemployeedialog = true;
      },
      selectDataBack(option) {
        if (option) {
          this.yg_num = option;
          this.editForm.yg_num = option;
        } else {
          this.yg_num = [];
          this.editForm.yg_num = [];
        }
      },
      updatePageInfo(option) {
        this.activity_list = [];
        let arr = [];
        for (let i = 0; i < option.length; i++) {
          this.activity_list.push({activity_id: option[i].activity_id, title: option[i].activity_title})
          arr.push(option[i].activity_id);
        }
        this.editForm.aids = arr.join(',');
      },
    }
  };
</script>
<style>
.w160{width: 260px;}
</style>